import api from './api';

export const getAdminStats = () => api.get('/admin/stats');

export const getAdminUsers = (params) =>
  api.get('/admin/users', { params });

export const getAdminUser = (userId) => api.get(`/admin/users/${userId}`);

export const updateAdminUser = (userId, updates) =>
  api.put(`/admin/users/${userId}`, updates);

export const deleteAdminUser = (userId) =>
  api.delete(`/admin/users/${userId}`);

export const sendPasswordReset = (userId) =>
  api.post(`/admin/users/${userId}/send-password-reset`);

export const getAdminPricing = () => api.get('/admin/pricing');

export const updateAdminPricing = (planId, data) =>
  api.put(`/admin/pricing/${planId}`, data);

export const getPricingEnforcement = () =>
  api.get('/admin/pricing/settings');

export const updatePricingEnforcement = (data) =>
  api.put('/admin/pricing/settings', data);

export const getAIAnalysisSettings = () =>
  api.get('/admin/ai-analysis/settings');

export const updateAIAnalysisSettings = (data) =>
  api.put('/admin/ai-analysis/settings', data);

export const testAIAnalysisSettings = (data) =>
  api.post('/admin/ai-analysis/settings/test', data);

export const getAITradingAgentSettings = () =>
  api.get('/admin/ai-trading-agent/settings');

export const updateAITradingAgentSettings = (data) =>
  api.put('/admin/ai-trading-agent/settings', data);

export const testAITradingAgentSettings = (data) =>
  api.post('/admin/ai-trading-agent/settings/test', data);

export const getAIProviderChain = (purpose) =>
  api.get(`/admin/ai-provider-chains/${purpose}`);

export const updateAIProviderChain = (purpose, data) =>
  api.put(`/admin/ai-provider-chains/${purpose}`, data);

export const testAIProviderChainSlot = (purpose, role, data) =>
  api.post(`/admin/ai-provider-chains/${purpose}/${role}/test`, data);

export const getAILearningStatus = () => api.get('/admin/ai-learning/status');

export const getReadinessEligibleAccounts = () =>
  api.get('/admin/readiness/eligible-accounts');

export const getReadinessTrials = () =>
  api.get('/admin/readiness/trials');

export const createReadinessTrial = (data) =>
  api.post('/admin/readiness/trials', data);

export const getReadinessReports = (params) =>
  api.get('/admin/readiness/reports', { params });

export const generateReadinessReport = (trialId, data) =>
  api.post(`/admin/readiness/trials/${trialId}/reports`, data);

export const activateOfficialReadinessTrial = (trialId) =>
  api.post(`/admin/readiness/trials/${trialId}/activate-official`);

export const getReadinessIncidents = (params) =>
  api.get('/admin/readiness/incidents', { params });

export const documentReadinessIncident = (incidentId, data) =>
  api.post(`/admin/readiness/incidents/${incidentId}/document`, data);

export const collectAILearningExamples = () => api.post('/admin/ai-learning/collect');

export const getAILearningExamples = (params) => api.get('/admin/ai-learning/examples', { params });

export const reviewAILearningExample = (exampleId, reviewStatus) =>
  api.post(`/admin/ai-learning/examples/${exampleId}/review`, { review_status: reviewStatus });

export const downloadAILearningDataset = () =>
  api.get('/admin/ai-learning/export.jsonl', { responseType: 'blob' });

export const getAdminNewsEvents = () => api.get('/admin/news-events');

export const updateAdminNewsEvents = (data) =>
  api.put('/admin/news-events', data);

export const getAdminSupportTickets = () =>
  api.get('/admin/support-tickets');

export const updateSupportTicket = (ticketId, status) =>
  api.put(`/admin/support-tickets/${ticketId}?status=${status}`);

export const getAdminExecutionOverview = () =>
  api.get('/admin/execution/overview');

export const getAdminExecutionJobs = (params) =>
  api.get('/admin/execution/jobs', { params });

export const retryExecutionJob = (jobId) =>
  api.post(`/admin/execution/jobs/${jobId}/retry`);

export const previewDeadLetterCleanup = (data) =>
  api.post('/admin/execution/dead-letter-cleanup/preview', data);

export const applyDeadLetterCleanup = (data) =>
  api.post('/admin/execution/dead-letter-cleanup/apply', data);

export const getAdminFillPollHistory = (params) =>
  api.get('/admin/execution/fill-poll-history', { params });

export const getAdminFillPollStats = (params) =>
  api.get('/admin/execution/fill-poll-stats', { params });

export const getAdminBrokers = () => api.get('/admin/brokers');

export const updateAdminBroker = (brokerId, data) =>
  api.put(`/admin/brokers/${brokerId}`, data);

export const getAdminMarketDataRefreshJobs = (params) =>
  api.get('/admin/market-data/refresh-jobs', { params });

export const getAdminMarketDataCoverage = () =>
  api.get('/admin/market-data/coverage');

export const getAdminMarketDataSymbols = () =>
  api.get('/admin/market-data/symbols');

export const triggerMarketDataRefresh = (data) =>
  api.post('/admin/market-data/refresh', data);

export const previewBrokerGapRepair = (data) =>
  api.post('/admin/market-data/broker-gap-repair/preview', data);

export const applyBrokerGapRepair = (data) =>
  api.post('/admin/market-data/broker-gap-repair/apply', data);

export const getMarketDataBrowser = (params) =>
  api.get('/admin/market-data/browser', { params });

export const getAdminMarketSessionConfig = () =>
  api.get('/admin/market-session-config');

export const updateAdminMarketSessionConfig = (data) =>
  api.put('/admin/market-session-config', data);

export const getSystemSettings = () =>
  api.get('/admin/system-settings');

export const updateSystemSettings = (data) =>
  api.put('/admin/system-settings', data);

export const getNotificationSummarySchedule = () =>
  api.get('/admin/notification-summary-schedule');

export const updateNotificationSummarySchedule = (times) =>
  api.put('/admin/notification-summary-schedule', { times });

export const getKillSwitchStatus = () =>
  api.get('/admin/kill-switch');

export const toggleKillSwitch = (enabled) =>
  api.post('/admin/kill-switch', { enabled });

export const getResendStatus = () =>
  api.get('/admin/resend/status');

// Automation timing settings (Phase 2)
export const getAutomationTiming = (scope_type, scope_id) => {
  const params = { scope_type };
  if (scope_id) params.scope_id = scope_id;
  return api.get('/admin/automation/timing', { params });
};

export const putAutomationTiming = (payload) =>
  api.put('/admin/automation/timing', payload);

export const deleteAutomationTiming = (scope_type, scope_id) => {
  const params = { scope_type };
  if (scope_id) params.scope_id = scope_id;
  return api.delete('/admin/automation/timing', { params });
};
